module.exports = __webpack_public_path__ + "38b15764ff4a7ad170a00255b5676dea.fbx";